// 任务报表管理 API
// Deprecated: 当前 reports/* 后端路由尚未在服务端落地，dashboard 请使用 /bff/tasks/dashboard-statistics。
import { createAppRequest } from '@/services/request';

const request = createAppRequest();

// ==================== 任务报表管理 API ====================

// 任务报表相关接口
export const taskReportApi = {
  // 获取任务完成报表
  getTaskCompletionReport: (params?: {
    startDate?: string;
    endDate?: string;
    teamId?: string;
    memberId?: string;
  }) => {
    const searchParams = new URLSearchParams();
    if (params?.startDate) {
      searchParams.append('startDate', params.startDate);
    }
    if (params?.endDate) {
      searchParams.append('endDate', params.endDate);
    }
    if (params?.teamId) {
      searchParams.append('teamId', params.teamId);
    }
    if (params?.memberId) {
      searchParams.append('memberId', params.memberId);
    }

    return request<{
      totalTasks: number;
      completedTasks: number;
      completionRate: number;
      dailyCompletion: Array<{
        date: string;
        completed: number;
        total: number;
      }>;
    }>(`/bff/tasks/reports/completion?${searchParams.toString()}`, {
      method: 'GET',
    });
  },

  // 获取任务效率报表
  getTaskEfficiencyReport: (params?: {
    startDate?: string;
    endDate?: string;
    teamId?: string;
    memberId?: string;
  }) => {
    const searchParams = new URLSearchParams();
    if (params?.startDate) {
      searchParams.append('startDate', params.startDate);
    }
    if (params?.endDate) {
      searchParams.append('endDate', params.endDate);
    }
    if (params?.teamId) {
      searchParams.append('teamId', params.teamId);
    }
    if (params?.memberId) {
      searchParams.append('memberId', params.memberId);
    }

    return request<{
      averageCompletionTime: number;
      tasksPerDay: number;
      efficiencyScore: number;
      memberEfficiency: Array<{
        memberId: string;
        memberName: string;
        efficiencyScore: number;
        tasksCompleted: number;
      }>;
    }>(`/bff/tasks/reports/efficiency?${searchParams.toString()}`, {
      method: 'GET',
    });
  },

  // 获取任务逾期报表
  getTaskOverdueReport: (params?: { teamId?: string; memberId?: string }) => {
    const searchParams = new URLSearchParams();
    if (params?.teamId) {
      searchParams.append('teamId', params.teamId);
    }
    if (params?.memberId) {
      searchParams.append('memberId', params.memberId);
    }

    return request<{
      overdueTasks: number;
      overdueRate: number;
      overdueTasksList: Array<{
        taskId: string;
        title: string;
        dueDate: string;
        daysOverdue: number;
        assignee: string;
      }>;
    }>(`/bff/tasks/reports/overdue?${searchParams.toString()}`, {
      method: 'GET',
    });
  },

  // 获取个人任务报表
  getPersonalTaskReport: (params?: {
    startDate?: string;
    endDate?: string;
    memberId?: string;
  }) => {
    const searchParams = new URLSearchParams();
    if (params?.startDate) {
      searchParams.append('startDate', params.startDate);
    }
    if (params?.endDate) {
      searchParams.append('endDate', params.endDate);
    }
    if (params?.memberId) {
      searchParams.append('memberId', params.memberId);
    }

    return request<{
      totalTasks: number;
      completedTasks: number;
      inProgressTasks: number;
      overdueTasks: number;
      completionRate: number;
      averageCompletionTime: number;
      weeklyProgress: Array<{
        week: string;
        completed: number;
        created: number;
      }>;
    }>(`/bff/tasks/reports/personal?${searchParams.toString()}`, {
      method: 'GET',
    });
  },

  // 导出任务报表
  exportTaskReport: (
    reportType: string,
    params?: {
      startDate?: string;
      endDate?: string;
      teamId?: string;
      memberId?: string;
      format?: 'excel' | 'pdf' | 'csv';
    },
  ) => {
    const searchParams = new URLSearchParams();
    if (params?.startDate) {
      searchParams.append('startDate', params.startDate);
    }
    if (params?.endDate) {
      searchParams.append('endDate', params.endDate);
    }
    if (params?.teamId) {
      searchParams.append('teamId', params.teamId);
    }
    if (params?.memberId) {
      searchParams.append('memberId', params.memberId);
    }
    if (params?.format) {
      searchParams.append('format', params.format);
    }

    return request<{ downloadUrl: string }>(
      `/bff/tasks/reports/${reportType}/export?${searchParams.toString()}`,
      {
        method: 'GET',
      },
    );
  },
};
